import { FC, useState } from 'react';
import { captureException } from '@sentry/react';
import { Button, Typography } from 'antd';
import { TbTrash } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { userService } from '@/services/database';
import DeleteAccountModal from '@/shared/components/modals/GlobalModals/DeleteAccountModal';

const DangerZone: FC = (): JSX.Element => {
    const [deleteAccountModalVisible, setDeleteAccountModalVisible] = useState(false);

    const handleDeleteAccount = async (verificationCode: string) => {
        try {
            await userService.deleteAuthenticated({ acknowledged: true, verificationCode });

            localStorage.clear();

            window.location.href = '/auth/logout';
        } catch (error) {
            captureException(error);
            throw error;
        }
    };

    const { token } = useAntDesignTheme();

    return (
        <>
            <Typography.Title level={4} id='danger-zone'>
                Danger Zone
            </Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary }}>Delete your account.</Typography.Paragraph>
            <Button block danger type='primary' onClick={() => setDeleteAccountModalVisible(true)}>
                <TbTrash style={{ verticalAlign: '-0.125rem' }} />
                Delete Account
            </Button>
            <DeleteAccountModal
                open={deleteAccountModalVisible}
                setOpen={setDeleteAccountModalVisible}
                handleDeleteAccount={handleDeleteAccount}
            />
        </>
    );
};

export default DangerZone;
